import moment from 'moment'

const filter = {
  filterDate(val) {
    // return moment(val).format('YYYY-MM-DD HH:MM:SS')
    return moment(val).utcOffset(0).format('YYYY-MM-DD HH:mm:ss')
    // return moment(date).format('YYYY-MM-DD HH:mm:ss')
  },
  filterTime(val) {
    return moment(val).utcOffset(0).format('YYYY-MM-DD')
  }
}
export default filter
